module.exports = __webpack_public_path__ + "img/orkney-islands.fc388a38.svg";